import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SvgIcon, SvgIconSrc } from '../SvgIcon';
import { buttonVariants, Button } from '../Button';
import { Banner } from '../Banner';
import { useReportSubscriptionBanner } from '../../contexts/SubscriptionBanner.context';
const SubscriptionWarningBanner = ({ subscription = {} }) => {
  const [daysLeft, setDaysLeft] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const history = useHistory();
  const location = useLocation();

  // Check if banner should be hidden based on current page
  const shouldHideOnCurrentPage = () => {
    const currentPath = location.pathname;
    return (
      currentPath.includes('/subscription-suspended') ||
      currentPath.includes('/payment') ||
      currentPath.includes('/auth/') ||
      currentPath.includes('/select-company') ||
      currentPath.includes('/add-company')
    );
  };

  // Check sessionStorage on mount and when company changes
  useEffect(() => {
    if (subscription?.companyId) {
      const storageKey = `subscriptionBanner_${subscription.companyId}`;
      const isClosed = sessionStorage.getItem(storageKey);
      if (isClosed) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }
  }, [subscription?.companyId]);

  useEffect(() => {
    const calculateDaysLeft = () => {
      if (!subscription?.trialExpiryDate) return;

      const expiry = new Date(subscription?.trialExpiryDate);
      const now = new Date();
      const diff = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
      setDaysLeft(diff);
    };

    calculateDaysLeft();
    const interval = setInterval(calculateDaysLeft, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [subscription?.trialExpiryDate]);

  const handleUpgradeClick = () => {
    history.push('/subscription');
  };

  const handleClose = () => {
    setIsVisible(false);
    if (subscription?.companyId) {
      const storageKey = `subscriptionBanner_${subscription.companyId}`;
      const closeValue = `closed_${Date.now()}`;
      sessionStorage.setItem(storageKey, closeValue);
    }
  };
  // Don't show if no subscription object, trial expired, user closed it, or subscription is active
  const shouldShow = !(
    !subscription ||
    subscription.isTrialActive === false ||
    !subscription.trialExpiryDate ||
    daysLeft <= 0 ||
    !isVisible ||
    shouldHideOnCurrentPage() ||
    subscription.subscriptionStatus === 'active'
  );

  useReportSubscriptionBanner(shouldShow);

  if (!shouldShow) return null;

  return (
    <Banner
      icon={<SvgIcon src={SvgIconSrc.stopwatch} size={20} color="#856404" />}
      title={
        <>
          Your trial expires in{' '}
          <strong>
            {daysLeft} {daysLeft === 1 ? 'day' : 'days'}.
          </strong>
        </>
      }
      actions={
        <Button
          icon={SvgIconSrc.crown}
          iconSize={20}
          iconColor="#fff"
          text="Upgrade Now"
          onClick={handleUpgradeClick}
          variant={buttonVariants.primary_rounded}
        />
      }
      onClose={handleClose}
    >
      Upgrade now for uninterrupted access.
    </Banner>
  );
};

export default SubscriptionWarningBanner;
